
import { ToolbarService } from "@/services/toolbar-service";
import Vue from "vue";
import { AuthService } from "../../services/auth-service";

export default Vue.extend({
	data() {
		return {
			activeTab: 0,
			AuthService,
			loaded: false
		};
	},
	props: {},
	computed: {
		tabDefs(): {label: string, path: string}[] {
			let defs = [
				{label: "tabs.plan", path: "/account/price"},
				{label: "tabs.payment-methods", path: "/account/pay"},
				{label: "tabs.invoices", path: "/account/invoices"},
				{label: "tabs.profile", path: "/account/settings"}
			];
			if (this.AuthService.wfCompany.isPermanentlyActive() && !this.AuthService.wfCompany.IsDemo){
				defs.push({label: "tabs.service-pack", path: "/account/service-pack"});
			}
			defs.push({label: "tabs.referrals", path: "/account/referrals"});
			return defs;
		},
		tabs(): string[] {
			return this.tabDefs.map(t => this.$ct(t.label).toString());
		},
		isOwner(): boolean {
			if (!AuthService.wfUser) return false;
			return AuthService.wfUser.ID == AuthService.wfCompany.OwnerID;
		},
		demoExpired(): boolean {
			return AuthService.wfCompany.IsDemo && AuthService.wfCompany.isExpired();
		}
	},
	watch: {
		"$route.path": {
			immediate: true,
			handler(path: string) {
				ToolbarService.title = this.$ct("account");
				const aliases: Record<string, string> = {
					"/account/activate": "/account/pay"
				};
				const resolved = aliases[path] || path;
				const index = this.tabDefs.findIndex(t => t.path == resolved);
				if (index >= 0) {
					this.activeTab = index;
				} else {
					ToolbarService.title = "";
				}
			}
		}
	},
	methods: {
		async setTab(value: number) {
			const def = this.tabDefs[value];
			if (def) {
				await this.$router.push(def.path);
			}
		}
	},
	async created() {
		if (!this.isOwner && this.$route.path !== "/account/settings" && this.$route.path !== "/account/referrals") {
			await this.setTab(3);
		}else if (this.$route.path == "/account") {
			await this.setTab(0);
		}
		this.loaded = true;

	},
	i18nEx: {
		componentPrefix: "views.account"
	}
});
